import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bottomHalfParent: {
    alignSelf: 'stretch',
    backgroundColor: colors.neutral.cotton,
    borderTopLeftRadius: scale(15),
    borderTopRightRadius: scale(15),
    flex: 1,
    marginTop: -12,
  },
  deepLinkParent: { alignItems: 'center', flex: 1, justifyContent: 'center' },
  openAppButton: {
    backgroundColor: colors.primary.carnation,
    borderRadius: 24,
    elevation: 3,
    marginLeft: 16,
    marginRight: 16,
    marginTop: 24,
    paddingHorizontal: 32,
    paddingVertical: 12,
    shadowColor: colors.black,
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  openInAppText: { alignSelf: 'center', color: colors.neutral.cotton, fontSize: 16, fontWeight: 'bold' },
  playButton: {
    alignItems: 'center',
    alignSelf: 'center',
    height: 66,
    justifyContent: 'center',
    width: 220,
  },
  playImage: {
    height: 66,
    resizeMode: 'contain',
    width: 220,
  },
  webappPitchStyle: {
    height: 100,
    resizeMode: 'cover',
    width: 600,
  },
});

export default styles;
